import { createContext, useContext, useState } from "react";

export const LANGS = [
  { code: "mr", label: "मराठी" },
  { code: "hi", label: "हिंदी" },
  { code: "en", label: "English" },
];

export const translations = {
  mr: {
    party_name: "समता पार्टी",
    party_state: "महाराष्ट्र प्रदेश",
    tagline: "परिवर्तन संकल्प, समता विकल्प",
    nav_home: "मुख्यपृष्ठ",
    nav_about: "आमच्याबद्दल",
    nav_constitution: "घटना",
    nav_elections: "निवडणुका",
    nav_rnvp: "RNVP महाराष्ट्र",
    nav_membership: "सदस्यत्व",
    nav_media: "मीडिया",
    nav_donation: "देणगी",
    nav_login: "सदस्य लॉगिन",
    nav_dashboard: "माझे डॅशबोर्ड",
    nav_admin: "अ‍ॅडमिन",
    logout: "बाहेर पडा",
    hero_title: "समता पार्टी महाराष्ट्र",
    hero_subtitle: "सामाजिक न्याय, समानता आणि सक्षमीकरणासाठी — मशाल हाच आमचा ठेवा!",
    join_now: "आत्ताच सामील व्हा",
    donate_now: "देणगी द्या",
    member_login: "सदस्य लॉगिन",
    admin_login: "अ‍ॅडमिन लॉगिन",
    stats_members: "एकूण सदस्य",
    stats_districts: "जिल्हे",
    stats_villages: "गावे",
    stats_levels: "स्तर",
    levels_title: "आमची संघटनात्मक रचना",
    levels_subtitle: "गावापासून राज्यापर्यंत — पाच स्तरांवर सशक्त संघटना",
    level_state: "राज्य स्तर",
    level_district: "जिल्हा स्तर",
    level_block: "तालुका / गट स्तर",
    level_city: "शहर स्तर",
    level_village: "ग्रामपंचायत / गाव स्तर",
    form_name: "पूर्ण नाव",
    form_mobile: "मोबाईल नंबर",
    form_email: "ईमेल (ऐच्छिक)",
    form_password: "पासवर्ड",
    form_level: "सदस्यत्व स्तर",
    form_district: "जिल्हा",
    form_taluka: "तालुका (ऐच्छिक)",
    form_city: "शहर (ऐच्छिक)",
    form_village: "गाव (ऐच्छिक)",
    form_address: "पत्ता (ऐच्छिक)",
    form_designation: "पदनाम (उदा. सदस्य, जिल्हाध्यक्ष)",
    form_photo: "फोटो (ऐच्छिक)",
    submit: "सबमिट करा",
    register_title: "समता पार्टी सदस्यता फॉर्म",
    login_title: "सदस्य लॉगिन",
    login_button: "लॉगिन करा",
    idcard_title: "डिजिटल ओळखपत्र",
    member_id: "सदस्य क्रमांक",
    designation: "पदनाम",
    level: "स्तर",
    district: "जिल्हा",
    joining_date: "सामील होण्याची तारीख",
    print_card: "ओळखपत्र प्रिंट करा",
    mobile_label: "मोबाईल",
    donation_title: "देणगी द्या",
    donation_subtitle: "समता पार्टीच्या कार्याला पाठबळ द्या — प्रत्येक योगदान मोलाचे!",
    upi_id: "UPI आयडी",
    bank_details: "बँक तपशील",
    account_name: "खाते नाव",
    account_number: "खाते क्रमांक",
    ifsc: "IFSC कोड",
    bank_name: "बँकेचे नाव",
    branch: "शाखा",
    copy: "कॉपी करा",
    copied: "कॉपी झाले!",
    amount: "रक्कम (₹)",
    message: "संदेश (ऐच्छिक)",
    donation_form_title: "देणगीची माहिती पाठवा",
    donation_form_sub: "UPI/बँकेतून देणगी दिल्यानंतर तपशील भरा — पावतीसाठी आम्ही संपर्क करू",
    contact_title: "संपर्क",
    office_address: "कार्यालय क्र.२, घोडगे सदन, वडेघर सर्कल, कल्याण पश्चिम ४२१३०१, महाराष्ट्र",
    phone: "फोन",
    email: "ईमेल",
    follow_us: "आम्हाला फॉलो करा",
    quick_links: "महत्वाच्या लिंक्स",
    rights: "सर्व हक्क राखीव",
    media_title: "मीडिया गॅलरी",
    media_empty: "लवकरच फोटो आणि व्हिडिओ उपलब्ध होतील",
    welcome: "स्वागत आहे",
    profile: "प्रोफाइल",
    edit_profile: "प्रोफाइल संपादित करा",
    save: "जतन करा",
    status_label: "स्थिती",
    pending: "प्रलंबित",
    approved: "मंजूर",
    admin_dashboard: "अ‍ॅडमिन डॅशबोर्ड",
    tab_members: "सदस्य",
    tab_donations: "देणग्या",
    tab_messages: "संदेश",
    tab_settings: "देणगी सेटिंग्ज",
    tab_media: "मीडिया",
    tab_site: "वेबसाइट सेटिंग्ज",
    tab_pages: "पृष्ठे",
    add_section: "विभाग जोडा",
    section_title: "शीर्षक",
    section_body: "मजकूर",
    pages_hint: "मजकुरात रिकामी ओळ = नवीन परिच्छेद; '- ' ने सुरू होणारी ओळ = बुलेट पॉइंट.",
    search_placeholder: "नाव / मोबाईल / सदस्य क्र. शोधा",
    all_levels: "सर्व स्तर",
    approve: "मंजूर करा",
    mark_pending: "प्रलंबित करा",
    no_data: "माहिती उपलब्ध नाही",
    add_media: "मीडिया जोडा",
    media_type: "प्रकार",
    upload_file: "किंवा फाइल अपलोड करा (PDF/फोटो)",
    view_pdf: "PDF पहा / डाउनलोड करा",
    media_url: "फोटो URL / YouTube Embed URL",
    media_title_field: "शीर्षक",
    delete: "हटवा",
    contact_form_title: "आम्हाला संदेश पाठवा",
    contact_success: "तुमचा संदेश पाठवला गेला!",
    donation_success: "धन्यवाद! तुमची देणगी माहिती नोंदवली गेली.",
    register_success: "अभिनंदन! तुमचे सदस्यत्व यशस्वी झाले.",
    login_success: "यशस्वी लॉगिन!",
    profile_saved: "प्रोफाइल जतन झाले",
    about_title: "आमच्याबद्दल",
    constitution_title: "पक्ष घटना",
    elections_title: "निवडणुका",
    rnvp_title: "राष्ट्र निर्माण विद्यार्थी परिषद (RNVP) महाराष्ट्र",
    membership_title: "सदस्यत्व",
    home_about_cta: "अधिक वाचा",
    leaders_title: "आमचे नेते",
    founder: "संस्थापक",
    saviour: "पक्षाचे रक्षक",
    read_more: "अधिक वाचा",
    view_idcard: "माझे ओळखपत्र पहा",
    not_member_cta: "समता पार्टीत सामील व्हा",
    secure_site: "सुरक्षित वेबसाइट",
  },
  hi: {
    party_name: "समता पार्टी",
    party_state: "महाराष्ट्र प्रदेश",
    tagline: "परिवर्तन संकल्प, समता विकल्प",
    nav_home: "होम",
    nav_about: "हमारे बारे में",
    nav_constitution: "संविधान",
    nav_elections: "चुनाव",
    nav_rnvp: "RNVP महाराष्ट्र",
    nav_membership: "सदस्यता",
    nav_media: "मीडिया",
    nav_donation: "दान",
    nav_login: "सदस्य लॉगिन",
    nav_dashboard: "मेरा डैशबोर्ड",
    nav_admin: "एडमिन",
    logout: "लॉगआउट",
    hero_title: "समता पार्टी महाराष्ट्र",
    hero_subtitle: "सामाजिक न्याय, समानता और सशक्तिकरण के लिए — मशाल ही हमारी पहचान!",
    join_now: "अभी जुड़ें",
    donate_now: "दान करें",
    member_login: "सदस्य लॉगिन",
    admin_login: "एडमिन लॉगिन",
    stats_members: "कुल सदस्य",
    stats_districts: "जिले",
    stats_villages: "गाँव",
    stats_levels: "स्तर",
    levels_title: "हमारी संगठनात्मक संरचना",
    levels_subtitle: "गाँव से राज्य तक — पाँच स्तरों पर मज़बूत संगठन",
    level_state: "राज्य स्तर",
    level_district: "जिला स्तर",
    level_block: "ब्लॉक / तालुका स्तर",
    level_city: "शहर स्तर",
    level_village: "ग्राम पंचायत / गाँव स्तर",
    form_name: "पूरा नाम",
    form_mobile: "मोबाइल नंबर",
    form_email: "ईमेल (वैकल्पिक)",
    form_password: "पासवर्ड",
    form_level: "सदस्यता स्तर",
    form_district: "जिला",
    form_taluka: "तालुका (वैकल्पिक)",
    form_city: "शहर (वैकल्पिक)",
    form_village: "गाँव (वैकल्पिक)",
    form_address: "पता (वैकल्पिक)",
    form_designation: "पदनाम (जैसे सदस्य, जिला अध्यक्ष)",
    form_photo: "फोटो (वैकल्पिक)",
    submit: "सबमिट करें",
    register_title: "समता पार्टी सदस्यता फॉर्म",
    login_title: "सदस्य लॉगिन",
    login_button: "लॉगिन करें",
    idcard_title: "डिजिटल पहचान पत्र",
    member_id: "सदस्य संख्या",
    designation: "पदनाम",
    level: "स्तर",
    district: "जिला",
    joining_date: "जुड़ने की तिथि",
    print_card: "पहचान पत्र प्रिंट करें",
    mobile_label: "मोबाइल",
    donation_title: "दान करें",
    donation_subtitle: "समता पार्टी के कार्य को समर्थन दें — हर योगदान मूल्यवान है!",
    upi_id: "UPI आईडी",
    bank_details: "बैंक विवरण",
    account_name: "खाता नाम",
    account_number: "खाता संख्या",
    ifsc: "IFSC कोड",
    bank_name: "बैंक का नाम",
    branch: "शाखा",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया!",
    amount: "राशि (₹)",
    message: "संदेश (वैकल्पिक)",
    donation_form_title: "दान की जानकारी भेजें",
    donation_form_sub: "UPI/बैंक से दान करने के बाद विवरण भरें — रसीद के लिए हम संपर्क करेंगे",
    contact_title: "संपर्क",
    office_address: "कार्यालय नं.२, घोडगे सदन, वडेघर सर्कल, कल्याण पश्चिम ४२१३०१, महाराष्ट्र",
    phone: "फोन",
    email: "ईमेल",
    follow_us: "हमें फॉलो करें",
    quick_links: "महत्वपूर्ण लिंक्स",
    rights: "सर्वाधिकार सुरक्षित",
    media_title: "मीडिया गैलरी",
    media_empty: "जल्द ही फोटो और वीडियो उपलब्ध होंगे",
    welcome: "स्वागत है",
    profile: "प्रोफ़ाइल",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    save: "सहेजें",
    status_label: "स्थिति",
    pending: "लंबित",
    approved: "स्वीकृत",
    admin_dashboard: "एडमिन डैशबोर्ड",
    tab_members: "सदस्य",
    tab_donations: "दान",
    tab_messages: "संदेश",
    tab_settings: "दान सेटिंग्स",
    tab_media: "मीडिया",
    tab_site: "वेबसाइट सेटिंग्स",
    tab_pages: "पेज",
    add_section: "सेक्शन जोड़ें",
    section_title: "शीर्षक",
    section_body: "सामग्री",
    pages_hint: "खाली लाइन = नया पैराग्राफ; '- ' से शुरू होने वाली लाइन = बुलेट पॉइंट।",
    search_placeholder: "नाम / मोबाइल / सदस्य सं. खोजें",
    all_levels: "सभी स्तर",
    approve: "स्वीकृत करें",
    mark_pending: "लंबित करें",
    no_data: "कोई जानकारी उपलब्ध नहीं",
    add_media: "मीडिया जोड़ें",
    media_type: "प्रकार",
    upload_file: "या फ़ाइल अपलोड करें (PDF/फोटो)",
    view_pdf: "PDF देखें / डाउनलोड करें",
    media_url: "फोटो URL / YouTube Embed URL",
    media_title_field: "शीर्षक",
    delete: "हटाएं",
    contact_form_title: "हमें संदेश भेजें",
    contact_success: "आपका संदेश भेज दिया गया!",
    donation_success: "धन्यवाद! आपकी दान जानकारी दर्ज हो गई।",
    register_success: "बधाई हो! आपकी सदस्यता सफल रही।",
    login_success: "लॉगिन सफल!",
    profile_saved: "प्रोफ़ाइल सहेजी गई",
    about_title: "हमारे बारे में",
    constitution_title: "पार्टी संविधान",
    elections_title: "चुनाव",
    rnvp_title: "राष्ट्र निर्माण विद्यार्थी परिषद (RNVP) महाराष्ट्र",
    membership_title: "सदस्यता",
    home_about_cta: "और पढ़ें",
    leaders_title: "हमारे नेता",
    founder: "संस्थापक",
    saviour: "पार्टी के रक्षक",
    read_more: "और पढ़ें",
    view_idcard: "मेरा पहचान पत्र देखें",
    not_member_cta: "समता पार्टी से जुड़ें",
    secure_site: "सुरक्षित वेबसाइट",
  },
  en: {
    party_name: "Samata Party",
    party_state: "Maharashtra Pradesh",
    tagline: "Parivartan Sankalp, Samata Vikalp",
    nav_home: "Home",
    nav_about: "About Us",
    nav_constitution: "Constitution",
    nav_elections: "Elections",
    nav_rnvp: "RNVP Maharashtra",
    nav_membership: "Membership",
    nav_media: "Media",
    nav_donation: "Donation",
    nav_login: "Member Login",
    nav_dashboard: "My Dashboard",
    nav_admin: "Admin",
    logout: "Logout",
    hero_title: "Samata Party Maharashtra",
    hero_subtitle: "For Social Justice, Equality & Empowerment — the Flaming Torch is our identity!",
    join_now: "Join Now",
    donate_now: "Donate",
    member_login: "Member Login",
    admin_login: "Admin Login",
    stats_members: "Total Members",
    stats_districts: "Districts",
    stats_villages: "Villages",
    stats_levels: "Levels",
    levels_title: "Our Organisational Structure",
    levels_subtitle: "From village to state — a strong organisation across five levels",
    level_state: "State Level",
    level_district: "District Level",
    level_block: "Block / Taluka Level",
    level_city: "City Level",
    level_village: "Village / Gram Panchayat Level",
    form_name: "Full Name",
    form_mobile: "Mobile Number",
    form_email: "Email (optional)",
    form_password: "Password",
    form_level: "Membership Level",
    form_district: "District",
    form_taluka: "Taluka (optional)",
    form_city: "City (optional)",
    form_village: "Village (optional)",
    form_address: "Address (optional)",
    form_designation: "Designation (e.g. Member, District President)",
    form_photo: "Photo (optional)",
    submit: "Submit",
    register_title: "Samata Party Membership Form",
    login_title: "Member Login",
    login_button: "Login",
    idcard_title: "Digital Identity Card",
    member_id: "Member ID",
    designation: "Designation",
    level: "Level",
    district: "District",
    joining_date: "Date of Joining",
    print_card: "Print ID Card",
    mobile_label: "Mobile",
    donation_title: "Donate",
    donation_subtitle: "Support the work of Samata Party — every contribution matters!",
    upi_id: "UPI ID",
    bank_details: "Bank Details",
    account_name: "Account Name",
    account_number: "Account Number",
    ifsc: "IFSC Code",
    bank_name: "Bank Name",
    branch: "Branch",
    copy: "Copy",
    copied: "Copied!",
    amount: "Amount (₹)",
    message: "Message (optional)",
    donation_form_title: "Submit Donation Details",
    donation_form_sub: "After donating via UPI/Bank, fill the details — we will contact you with a receipt",
    contact_title: "Contact",
    office_address: "Office No.2, Ghodge Sadan, Wadeghar Circle, Kalyan West 421301, Maharashtra",
    phone: "Phone",
    email: "Email",
    follow_us: "Follow Us",
    quick_links: "Quick Links",
    rights: "All rights reserved",
    media_title: "Media Gallery",
    media_empty: "Photos and videos coming soon",
    welcome: "Welcome",
    profile: "Profile",
    edit_profile: "Edit Profile",
    save: "Save",
    status_label: "Status",
    pending: "Pending",
    approved: "Approved",
    admin_dashboard: "Admin Dashboard",
    tab_members: "Members",
    tab_donations: "Donations",
    tab_messages: "Messages",
    tab_settings: "Donation Settings",
    tab_media: "Media",
    tab_site: "Site Settings",
    tab_pages: "Pages",
    add_section: "Add Section",
    section_title: "Title",
    section_body: "Content",
    pages_hint: "Blank line = new paragraph; a line starting with '- ' becomes a bullet point.",
    search_placeholder: "Search name / mobile / member ID",
    all_levels: "All Levels",
    approve: "Approve",
    mark_pending: "Mark Pending",
    no_data: "No data available",
    add_media: "Add Media",
    media_type: "Type",
    upload_file: "Or upload a file (PDF/Image)",
    view_pdf: "View / Download PDF",
    media_url: "Photo URL / YouTube Embed URL",
    media_title_field: "Title",
    delete: "Delete",
    contact_form_title: "Send Us a Message",
    contact_success: "Your message has been sent!",
    donation_success: "Thank you! Your donation details have been recorded.",
    register_success: "Congratulations! Your membership is successful.",
    login_success: "Login successful!",
    profile_saved: "Profile saved",
    about_title: "About Us",
    constitution_title: "Party Constitution",
    elections_title: "Elections",
    rnvp_title: "Rashtra Nirman Vidyarthi Parishad (RNVP) Maharashtra",
    membership_title: "Membership",
    home_about_cta: "Read More",
    leaders_title: "Our Leaders",
    founder: "Founder",
    saviour: "Saviour of the Party",
    read_more: "Read More",
    view_idcard: "View My ID Card",
    not_member_cta: "Join Samata Party",
    secure_site: "Secured Website",
  },
};

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("mr");
  return (
    <LangCtx.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
